import { render, staticRenderFns } from "./goodsType.vue?vue&type=template&id=d06875b6&"
import script from "./goodsType.vue?vue&type=script&lang=js&"
export * from "./goodsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports